import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { AutocompleteItem } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/AutocompleteItem/autocompleteItem";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { CONTENT_PAGES_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";

type Props = {
    className?: string;
};

export const Item = ({ className }: Props) => {
    const { items } = useResults(CONTENT_PAGES_SOURCE_ID);
    const { autocompleteState, autocompleteActions } = useSearchBarContext();
    const { index } = useMapped();

    const item = items[index];

    return (
        <AutocompleteItem
            itemId={item.__autocomplete_id}
            href={item.externalPath}
            className={cn(
                "tw:rounded-sm tw:no-underline tw:flex tw:items-center tw:min-w-0",
                className
            )}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
        >
            <i className={cn("las la-arrow-right", "tw:pr-2")}></i>
            <span
                className={cn(
                    "tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis"
                )}
            >
                {item.title}
            </span>
        </AutocompleteItem>
    );
};
